import HorariosPrestadores from "../../../pages/HorariosPrestadores/HorariosPrestadores";
import ImagenesPaciente from "../../../pages/Imagenes/Imagenes";
import TurnosPaciente from "../../../pages/TurnosPaciente/TurnosPaciente";
import Configuraciones from "../../../pages/Configuraciones/Configuraciones";
import PageError from "../../../pages/PageError/PageError";
import MainPage from "../../../pages/MainPage/MainPage";
import NuevoTurnoImagenes from "../../../pages/NuevoTurnoImagenes/NuevoTurnoImagenes";
import MisDatos from "../../../pages/MisDatos/MisDatos";

interface ContainerProps {
  name: string;
}

const ExploreContainer: React.FC<ContainerProps> = ({ name }) => {
  return (
    <div className="container">
      <div className="container">
        {(() => {
          switch (name) {
            case "Estudios":
              return <ImagenesPaciente />;
            case "Turnos":
              return <TurnosPaciente />;
            case "Horarios":
              return <HorariosPrestadores />;
            case "Reservar turno":
              return <NuevoTurnoImagenes />;
            case "Reservar turnos imágenes":
              return <NuevoTurnoImagenes />;
            case "Datos":
              return <MisDatos />;
            case "Configuraciones":
              return <Configuraciones />;
            case "Inicio":
              return <MainPage />;
            default:
              return <PageError motivo="404" />;
          }
        })()}
      </div>
    </div>
  );
};

export default ExploreContainer;
